import IFilter from '../../interfaces/AceleraMagenta/index/IFilter'
import { IBrilhaMagentaAiPrompt } from '../../interfaces/BrilhaMagenta/IBrilhaMagentaAiPrompt'
import { IBrilhaMagentaAiSuggestion } from '../../interfaces/BrilhaMagenta/IBrilhaMagentaAiSuggestion'
import { IBrilhaMagentaStore } from '../../interfaces/BrilhaMagenta/IBrilhaMagentaStore'
import { IAceleraMagentaAnswer } from '../../interfaces/IAceleraMagentaAnswer'
import apiService from '../Api'

export default class BrilhaMagentaService {
  async list(filter: IFilter) {
    return apiService.get('/brilha-magenta', { params: filter })
  }

  async getStep(id: number) {
    return apiService.get(`/brilha-magenta/get-step/${id}`)
  }

  async getResponses(id: number, step: number) {
    return apiService.get(`/brilha-magenta/get-responses/${id}/${step}`)
  }

  async getSteps() {
    return apiService.get(`/brilha-magenta/get-steps`)
  }

  async store(data: IBrilhaMagentaStore) {
    return apiService.post('/brilha-magenta', data)
  }

  async update(id: number, data: IAceleraMagentaAnswer) {
    return apiService.put(`/brilha-magenta/${id}`, { answers: data })
  }

  async delete(id: number) {
    return apiService.delete(`/brilha-magenta/${id}`)
  }

  async getEmployeeNote(uuid: string) {
    return apiService.get(`/brilha-magenta/nota-colaborador/${uuid}`)
  }

  async saveEmployeeNote(uuid: string, answer: string) {
    return apiService.post(`/brilha-magenta/nota-colaborador/${uuid}`, { answer })
  }

  /** Lê a transcrição com IA e devolve o texto sugerido para as perguntas do step de registro. */
  async suggestFromTranscript(id: number, transcript: File): Promise<IBrilhaMagentaAiSuggestion> {
    const formData = new FormData()
    formData.append('transcript', transcript)

    const { data } = await apiService.post(`/brilha-magenta/${id}/ai-suggestion`, formData)
    return data
  }

  async getAiPrompt(): Promise<IBrilhaMagentaAiPrompt> {
    const { data } = await apiService.get('/brilha-magenta/ai-prompt')
    return data
  }

  async updateAiPrompt(content: string): Promise<IBrilhaMagentaAiPrompt> {
    const { data } = await apiService.put('/brilha-magenta/ai-prompt', { content })
    return data
  }
}
